/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { retrieveEmojis } from './asyncThunks'
import { extractEmojiDisplayText } from '../../utils/emojiUtil'

const initialState = {
  status: 'idle',
  error: null,
  nameToDisplayMap: {}
}

const generateNameToDisplayMap = (emojiData) => {
  const emojiList = [].concat(
    [emojiData.allEmojis],
    emojiData.types,
    emojiData.emotions,
    emojiData.emojis
  )
  return emojiList.reduce((nameToDisplayMap, emojiItem) => {
    nameToDisplayMap[emojiItem.name] = extractEmojiDisplayText(emojiItem)
    return nameToDisplayMap
  }, {})
}

const emojiSlice = createSlice({
  name: 'retrieveEmojis',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(retrieveEmojis.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(retrieveEmojis.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.nameToDisplayMap = generateNameToDisplayMap(action.payload)
      })
      .addCase(retrieveEmojis.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload
      })
  }
})

export default emojiSlice.reducer
